import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        token: null,
        userIdentifier: null
    },
    reducers: {
        setCredentials: (state, action) => {
            const { data } = action.payload
            state.token = data?.data?.token?.accessToken

            localStorage.setItem('token', state.token)
        },
        logOut: (state, action) => {
            state.token = null
            localStorage.removeItem('token')
            localStorage.removeItem('persist:root')
            window.location.href = "/login";
        }
    }
})

export const { setCredentials, logOut } = authSlice.actions
export const authReducer = authSlice.reducer
// export const selectCurrentToken = (state) => state.auth.token